import { AxiosError, AxiosRequestConfig } from 'axios';
import { apiDelete, apiGet, apiPost, apiPut } from './api';

const { REACT_APP_CATALOG } = process.env;

interface IBrand {
  name?: string;
  imageId?: number | string;
  id?: number | string;
}

interface IImageDetail {
  url: string;
}
interface IDetailBrands {
  id?: number | string;
  name?: string;
  imageId?: number | string;
  image?: IImageDetail;
}

const getBrands = async (): Promise<IDetailBrands[]> => {
  return apiGet<AxiosRequestConfig, IDetailBrands[]>(`${REACT_APP_CATALOG}brand`)
    .then(resp => {
      const brandsList: IDetailBrands[] = resp;
      return brandsList;
    })
    .catch((error: AxiosError) => Promise.reject(error));
};

const editBrand = async (data: IBrand, brandId: number | string): Promise<string> => {
  return apiPut<AxiosRequestConfig, IBrand>(`${REACT_APP_CATALOG}brand/update/${brandId}`, data)
    .then(resp => {
      const respEdit: string = resp;
      return respEdit;
    })
    .catch((error: AxiosError) => Promise.reject(error));
};

const deleteIdBrand = async (brandId: number | string) => {
  return apiDelete<AxiosRequestConfig, string>(`${REACT_APP_CATALOG}/backoffice/delete-brand/${brandId}`)
    .then(resp => {
      const respDetele: string = resp;
      return respDetele;
    })
    .catch((error: AxiosError) => Promise.reject(error));
};

const createOneBrand = async (name: string) => {
  const data = { name: `test-brand-${name}`, imageId: 1 };
  return apiPost<AxiosRequestConfig, IBrand>(`${REACT_APP_CATALOG}brand`, data)
    .then(resp => {
      const respEdit: string = resp;
      return respEdit;
    })
    .catch((error: AxiosError) => Promise.reject(error));
};

const upSert = async (data: IBrand) => {
  return apiPost<AxiosRequestConfig, IBrand>(`${REACT_APP_CATALOG}brand/upsert`, data)
    .then(resp => {
      const respEdit: IBrand = resp;
      return respEdit;
    })
    .catch((error: AxiosError) => Promise.reject(error));
};

export { getBrands, editBrand, deleteIdBrand, createOneBrand, upSert };
